"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var React = require("react");
var Checkbox_style_1 = require("./Checkbox.style");
exports.Checkbox = function (_a) {
    var boxSize = _a.boxSize, checked = _a.checked, onChange = _a.onChange, name = _a.name, theme = _a.theme, children = _a.children, style = _a.style, title = _a.title, disabled = _a.disabled, required = _a.required, error = _a.error, checkBackground = _a.checkBackground, props = __rest(_a, ["boxSize", "checked", "onChange", "name", "theme", "children", "style", "title", "disabled", "required", "error", "checkBackground"]);
    return (React.createElement(Checkbox_style_1.default.Label, { boxSize: boxSize || (title ? 40 : 20), style: style, disabled: disabled, name: name, checked: checked, theme: theme, checkBackground: checkBackground },
        React.createElement(Checkbox_style_1.default.HiddenCheckbox, __assign({ disabled: disabled, name: name, checked: checked, onChange: onChange, "aria-labelledby": name }, props)),
        React.createElement(Checkbox_style_1.default.Icon, { viewBox: "0 0 24 24" },
            React.createElement("polyline", { points: "20 6 9 17 4 12" })),
        React.createElement(Checkbox_style_1.default.Content, null,
            title ? React.createElement(Checkbox_style_1.default.Title, null, title) : null,
            children ? (React.createElement(Checkbox_style_1.default.Description, null,
                children,
                " ",
                required ? "*" : null)) : null),
        error ? React.createElement(Checkbox_style_1.default.FieldError, null, error) : null));
};
exports.default = exports.Checkbox;
//# sourceMappingURL=Checkbox.js.map